<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Details" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- users list start -->
        <section class="app-user-list">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title"><BIconExclamationCircle width="32" height="32" /> Note</h4>
            </div>
            <div class="card-body">
              <div class="demo-spacing-0">
                <div class="alert alert-primary" role="alert">
                  <div class="alert-body">For queries and feedback please contact VaultsPay support team at: <strong><a href="mailto: support@vaultspay.com">support@vaultspay.com</a></strong></div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <h1 class="m-5"><img class="w-25" :src="`${publicPath}images/vaults-authlogo.png`"></h1>
          </div>
          <div class="row pricing-card">
            <div class="col-12 col-sm-offset-2 col-sm-10 col-md-12 col-lg-offset-2 col-lg-10 mx-auto">
              <div class="row">
                <!-- basic plan -->
                <div class="col-12 col-md-4">
                  <div class="card basic-pricing text-center border-warning badge-glow">
                    <div class="card-body">
                      <BIconPersonFill  width="100" height="100" class="text-warning"/>
                      <h3 class="mt-1 mb-2">From</h3>
                        <h6 class="mb-25">Customer</h6>
                        <p class="card-text mb-2">{{$store.getters.getTransactionDetail.sender.first_name+' '+$store.getters.getTransactionDetail.sender.last_name}}</p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                      <h6 class="mb-25">Account Number</h6>
                      <p class="card-text mb-2">{{$store.getters.getTransactionDetail.sender_account_number}}</p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                      <h6 class="mb-25">Email</h6>
                      <p class="card-text mb-2">{{$store.getters.getTransactionDetail.sender.email}}</p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                      <h6 class="mb-25">Phone</h6>
                      <p class="card-text mb-2">Shelby Company Limited</p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                    </div>
                  </div>
                </div>
                <!--/ basic plan -->

                <!-- enterprise plan -->
                <div class="col-12 col-md-4">
                  <div class="card enterprise-pricing text-center border-info badge-glow">
                    <div class="card-body">
                      <BIconStack  width="100" height="100" class="text-info"/>
                      <h3 class="mt-1 mb-2">Details</h3>
                      <h6 class="mb-25">Transaction</h6>
                      <p class="card-text mb-2 text-primary">{{$store.getters.getTransactionDetail.uuid}}</p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                      <h6 class="mb-25">Transaction Status</h6>
                      <p class="card-text mb-2"><div class="badge badge-pill badge-glow badge-light-success">Success</div></p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                      <h6 class="mb-25">Dated</h6>
                      <p class="card-text mb-2" v-if="$store.getters.getTransactionDetail.settlement_date">{{new Date($store.getters.getTransactionDetail.settlement_date).toDateString()}}</p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                      <h6 class="mb-25">Settlement Status</h6>
                      <p class="card-text mb-2">
                      <div v-if="$store.getters.getTransactionDetail.settlement_status == 0" class="badge badge-pill badge-glow badge-light-warning">Pending</div>
                      <div v-else-if="$store.getters.getTransactionDetail.settlement_status == 1" class="badge badge-pill badge-glow badge-light-info">Initiated</div>
                      <div v-else-if="$store.getters.getTransactionDetail.settlement_status == 2" class="badge badge-pill badge-glow badge-light-danger">Cancelled</div>
                      <div v-else class="badge badge-pill badge-glow badge-light-success">Done</div>
                      </p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                    </div>
                  </div>
                </div>
                <!--/ enterprise plan -->

                <!-- standard plan -->
                <div class="col-12 col-md-4">
                  <div class="card standard-pricing popular text-center border-success badge-glow">
                    <div class="card-body">
                      <BIconPersonCheckFill  width="100" height="100" class="text-success"/>
                      <h3 class="mt-1 mb-2">To</h3>
                      <h6 class="mb-25">Merchant</h6>
                      <p class="card-text mb-2">{{$store.getters.getTransactionDetail.receiver.first_name+' '+$store.getters.getTransactionDetail.receiver.last_name}}</p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                      <h6 class="mb-25">Account Number</h6>
                      <p class="card-text mb-2">{{$store.getters.getTransactionDetail.receiver_account_number}}</p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                      <h6 class="mb-25">Settlement</h6>
                      <p class="card-text mb-2">Waiting</p>
                      <div class="col-12">
                        <hr class="my-2" />
                      </div>
                    </div>
                  </div>
                </div>
                <!--/ standard plan -->

              </div>
            </div>
          </div>
        </section>
        <!-- users list ends -->

      </div>
    </div>
  </div>
</template>

<script>

export default {
  mounted() {

  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Transactions'},
        {name: 'Details'},
      ],

    }
  },
  methods: {

  },

}
</script>


